import React, { FC } from 'react';

import { styled } from '@mui/material';

import Skill from '~/components/Skill/Skill';
import { H4 } from '~/components/UI/Texts';
import useTenantTranslation from '~/hooks/useTenantTranslation';
import { buildSkillRoute } from '~/routes';
import { SMALL_MARGIN_PX, TINY_MARGIN_PX } from '~/theme';
import { Maybe, Skill as SkillType } from '~/types';

interface SkillBlockProps {
  skills: Maybe<SkillType>[];
  withoutTitle?: boolean;
}

const SkillsBlock: FC<SkillBlockProps> = ({ skills, withoutTitle = false }) => {
  const { t } = useTenantTranslation();
  return (
    <Wrapper>
      {!withoutTitle && <H4>{t('page.discover.skills')}:</H4>}
      <SkillsBox>
        {skills.map((skill) => (
          <Skill key={skill?.id} link={buildSkillRoute(skill?.slug)}>
            {skill?.title}
          </Skill>
        ))}
      </SkillsBox>
    </Wrapper>
  );
};

export default SkillsBlock;

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${TINY_MARGIN_PX};

  ${({ theme }) => theme.breakpoints.up('md')} {
    align-items: center;
    flex-direction: row;
    gap: ${SMALL_MARGIN_PX};
  }
`;
const SkillsBox = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: ${TINY_MARGIN_PX};
  align-items: center;
`;
